import {Able, MoveableManagerInterface} from "moveable";
import {Renderer} from "react-moveable/types";
import React from "preact/compat";
import Interactable from "../interactable";
import {ABLE_OFFSET} from "../interactable-constants";

interface LockedViewableProps {
  lockedViewable: boolean;
  interactable: Interactable;
}

const LockedViewable = {
  name: "lockedViewable",
  always: true,
  props: {
    interactable: Interactable
  },
  render(moveable: MoveableManagerInterface<LockedViewableProps>, _renderer: Renderer) {
    const rect = moveable.getRect();

    const locked = moveable.props.interactable.isLocked() && moveable.props.interactable.isSelected();
    const empty = ' ';
    const id = moveable.props.interactable.getElement().attr('id');

    return <div key={`locked-${id}`} className={"moveable-locked hint--bottom"} style={{
      position: "absolute",
      left: `${rect.width / 2}px`,
      top: `${rect.height + ABLE_OFFSET.LOCKED}px`,
      background: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='64 64 896 896' fill='%23black'%3E%3Cpath d='M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z'%3E%3C/path%3E%3C/svg%3E") no-repeat`,
      borderRadius: "50%",
      border: "1px solid #ddd",
      boxShadow: "0 0 2px #ddd",
      padding: "2px 4px",
      color: "white",
      fontSize: "13px",
      whiteSpace: "nowrap",
      fontWeight: "bold",
      willChange: "transform",
      transform: "translate(-50%, -50%)",
      width: "25px",
      height: "25px",
      backgroundColor: "#fff",
      backgroundPosition: "center",
      backgroundSize: "15px 15px",
      marginTop: "7px",
      display: locked ? 'block' : 'none'
    }} data-hint="This element is locked">
      {empty}&nbsp;
    </div>
  },
} as Able;

export default LockedViewable;
